import React from "react";
import "../assets/css/PolicyPages.css";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => (
  <>
  <Helmet>
      <title>Privacy Policy – Farmer Boaz</title>
      <meta name="description" content="How Farmer Boaz collects, uses and protects your personal information." />
    </Helmet>
  <div className="policy-container">
    <h1>Privacy Policy</h1>
    <p><strong>Effective Date:</strong> [05-19-2025]</p>
    <p>We care about your privacy. This policy explains what personal information we collect and how we use and protect it.</p>
    
    <h2>1. Information We Collect</h2>
    <ul>
      <li><b>Account & Contact Information:</b> Name, email, phone, delivery address, and account details you provide when ordering or registering.</li>
      <li><b>Order & Transaction Data:</b> Purchase history, payment status, and campaign participation.</li>
      <li><b>Community Interactions:</b> Posts, messages, and feedback via our website or community channels (e.g., Discord).</li>
    </ul>
    
    <h2>2. How We Use Your Information</h2>
    <ul>
      <li>To process your orders and deliver products.</li>
      <li>To communicate with you about orders, campaigns, or updates.</li>
      <li>To provide customer service and resolve issues.</li>
      <li>To improve our website and user experience.</li>
      <li>For legal and compliance purposes.</li>
    </ul>
    
    <h2>3. Sharing Your Information</h2>
    <ul>
      <li><b>We do not sell your personal information.</b></li>
      <li>Your data may be shared with delivery partners, payment processors, service providers, or legal authorities as required.</li>
      <li>Your participation in our Discord means your username and posts are visible to other members.</li>
    </ul>
    
    <h2>4. Cookies & Tracking</h2>
    <p>We may use cookies and similar technologies to help our site function and understand how users interact with it. You can control cookies in your browser settings.</p>
    
    <h2>5. Security</h2>
    <p>We use reasonable technical and organizational measures to protect your data. However, no online service is 100% secure; use Farmer Boaz at your own risk.</p>
    
    <h2>6. Your Rights</h2>
    <ul>
      <li>You can request to access, update, or delete your personal data by contacting us at <a href="mailto:info@farmerboaz.com">info@farmerboaz.com</a>.</li>
      <li>You can opt out of marketing emails at any time.</li>
    </ul>
    
    <h2>7. Children’s Privacy</h2>
    <p>Our site is not intended for children under 18. If you believe a child has provided us information, contact us to remove it.</p>
    
    <h2>8. Third Party Links</h2>
    <p>Our website and community may link to external sites (such as Discord). We are not responsible for their privacy policies.</p>
    
    <h2>9. Changes to this Policy</h2>
    <p>We may update this policy. We will notify you of significant changes via our website or by email.</p>
    
    <h2>10. Contact</h2>
    <p>For questions or privacy requests, email <a href="mailto:info@farmerboaz.com">info@farmerboaz.com</a>.</p>
  </div>
  </>
);

export default PrivacyPolicy;
